define(function () {
    function Validator() {
        var domain = partyking.config.country;
        var page = 'standard';

        var requiredFieldSettings = {
            customer: {
                ssn: false,
                company_number: false,
                first_name: true,
                last_name: true,
                address: true,
                zipcode: true,
                city: true,
                email: true,
                phone: true,
            },
            customerService: {
                name: true,
                email: true,
                message: true,
                orderid: false,
            },
            claimsForm: {
                orderid: true,
                name: true,
                message: true,
                reason: true,
                ticket_opened_before: true,
                action: true,
                'files[]': true,
            },
            productIdea: {
                message: true,
            },
            retailer: {
                company_name: true,
                company_number: true,
                first_name: true,
                last_name: true,
                address: true,
                zipcode: true,
                city: true,
                email: true,
                phone: true,
                message: false,
            },
            standard: {
                orderid: true,
                email: true,
                name: true,
                question: true,
                phone: true,
                zipcode: true,
            },
        };

        function init() {}

        function setPage(p) {
            page = p;
        }

        function validate(field, value) {
            var isRequired = false;
            var valid = true;

            if (
                requiredFieldSettings[page] &&
                requiredFieldSettings[page][field]
            ) {
                isRequired = true;
            }

            // om den inte är required och value är tomt så är den valid.
            if (!isRequired && !value) {
                return valid;
            }

            switch (field) {
                case 'email':
                    valid = isValidEmailAddress(value);
                    break;
                case 'ssn':
                    // valid = isValidDateOfBirth(value);
                    valid = isValidPnr(value);
                    break;
                case 'first_name':
                    valid = isValidFirstName(value);
                    break;
                case 'last_name':
                    valid = isValidLastName(value);
                    break;
                case 'company_name':
                case 'name':
                    valid = value.length >= 2;
                    break;
                case 'address':
                    valid = isValidStreetAddress(value);
                    break;
                case 'zipcode':
                    valid = isValidPostCode(value);
                    break;
                case 'city':
                    valid = isValidCity(value);
                    break;
                case 'phone':
                    valid = isValidTelephoneNumber(value);
                    break;
                case 'orderid':
                    valid = !_.isNaN(parseInt(value)) && value.length > 4;
                    break;
                case 'company_number':
                    valid = value.length > 4;
                    break;
                case 'contact_person':
                    valid = value.length > 2;
                    break;
                case 'message':
                    valid = value.length > 10;
                    break;
                case 'question':
                    valid = value.length > 15;
                    break;
                case 'country':
                    valid = value.length > 1;
                    break;
                default:
                    valid = value.length > 0;
                    break;
            }

            return valid;
        }

        /**
         * Kontrollera hurvida ett förnamn är korrekt.
         */
        function isValidFirstName(firstname) {
            var pattern = /^[^0-9!<>,;?=+()@#"°{}_$%:]*$/;
            var valid = firstname.length > 1;
            valid = valid ? pattern.test(firstname) : valid;

            return valid;
        }

        /**
         * Kontrollera hurvida ett efternamn är korrekt.
         */
        function isValidLastName(lastname) {
            return isValidFirstName(lastname);
        }

        /**
         * Kontrollera hurvida date_of_birthen är korrekt.
         */
        function isValidDateOfBirth(dateOfBirth) {
            var valid = true;
            var pattern = false;

            switch (domain) {
                case 'SE':
                    pattern = /^\d{6}\-\d{4}$|\d{8}\-\d{4}$|\d{10}|\d{12}$/;
                    break;
                case 'NO':
                case 'FI':
                case 'DK': // dagmånår 270191
                    pattern = /^[0-3][0-9][0-1][0-9][0-9][0-9]$/;
                    break;
                case 'NL':
                    pattern = /^[0-3][0-9][0-1][0-9][0-9][0-9][0-9][0-9]$/;
                    break;
            }
            if (pattern) {
                valid = pattern.test(dateOfBirth);
            } else {
                valid = dateOfBirth.length > 3;
            }

            return valid;
        }

        function isValidPnr(number) {
            var valid = false;
            var pnr = new personnummer(number);

            switch (domain) {
                case 'SE':
                    valid = pnr.se.valid();
                    break;
                case 'NO': // dagmånår 270191
                    valid = pnr.no.valid();
                    break;
                case 'FI': // dagmånår 270191
                    valid = pnr.fi.valid();
                    break;
            }

            return valid;
        }

        /**
         * Kontrollera hurvida adressen är giltlig.
         */
        function isValidStreetAddress(address) {
            var valid = address.length > 1;
            var pattern = /^[^!<>?=+@{}_$%]*$/;
            valid = valid ? pattern.test(address) : valid;

            return valid;
        }

        /**
         * Validera postnummer.
         */
        function isValidPostCode(postcode) {
            var valid = false;

            var pattern = /^[a-zA-Z 0-9-]+$/;

            switch (domain) {
                case 'SE':
                    // valid = postcode.length == 5;
                    valid = postcode.length == 5;
                    break;
                case 'NO': // dagmånår 270191
                    valid = postcode.length == 4;
                    break;
                case 'DK': // dagmånår 270191
                    valid = postcode.length == 4;
                    break;
                case 'FI': // dagmånår 270191
                    valid = postcode.length == 5;
                    break;
                default:
                    valid = postcode.length > 0;
            }

            valid = valid ? pattern.test(postcode) : valid;

            return valid;
        }

        /**
         * Validera stad.
         */
        function isValidCity(city) {
            valid = city.length > 1;
            var pattern = /^[^<>;?=+@#"°{}_$%]*$/;
            valid = valid ? pattern.test(city) : valid;

            return valid;
        }

        /**
         * Validera telefonnummer.
         */
        function isValidTelephoneNumber(phoneNumber) {
            var pattern = /^[+0-9. ()-]+$/;
            return pattern.test(phoneNumber);
        }

        /**
         * Validera epostadress.
         */
        function isValidEmailAddress(email) {
            var pattern = /\S+@\S+\.\S+/;
            return pattern.test(email);
        }

        /**
         * Validera personnummer
         */
        function isValidSocialSecurityNumber(SSNumber) {
            var valid = SSNumber.length > 1;
            return valid;
        }

        function personnummer(nr) {
            _this = this;
            this.pnr = nr;
            this.se = {
                valid: function () {
                    _this.pnr = _this.pnr.replace('-', '');

                    if (
                        !/^\d{10}$/.test(_this.pnr) &&
                        !/^\d{12}$/.test(_this.pnr)
                    ) {
                        return false;
                    }

                    if (_this.pnr.length == 12) {
                        _this.pnr = _this.pnr.slice(2);
                    }

                    var n = _this.pnr.split(''),
                        s = 0;

                    for (var i = 0, l = n.length - 1; i < l; ++i) {
                        if (i % 2 == 0) {
                            if (2 * n[i] > 9) {
                                var t = Number(2 * n[i]).toString();
                                s +=
                                    parseInt(t.charAt(0)) +
                                    parseInt(t.charAt(1));
                            } else {
                                s += 2 * n[i];
                            }
                        } else {
                            s += 1 * n[i];
                        }
                    }

                    if (Math.ceil(s / 10) * 10 - s != n[9]) {
                        return false;
                    }

                    return true;
                },
            };
            this.no = {
                valid: function () {
                    if (!/^\d{11}$/.test(_this.pnr)) {
                        return false;
                    }

                    var n = _this.pnr.split(''),
                        v1 = (v2 = k1 = k2 = 0);

                    v1 =
                        3 * n[0] +
                        7 * n[1] +
                        6 * n[2] +
                        1 * n[3] +
                        8 * n[4] +
                        9 * n[5] +
                        4 * n[6] +
                        5 * n[7] +
                        2 * n[8];

                    if (v1 % 11 != 0) {
                        k1 = 11 - (v1 % 11);
                    }

                    v2 =
                        5 * n[0] +
                        4 * n[1] +
                        3 * n[2] +
                        2 * n[3] +
                        7 * n[4] +
                        6 * n[5] +
                        5 * n[6] +
                        4 * n[7] +
                        3 * n[8] +
                        2 * k1;

                    if (v2 % 11 != 0) {
                        k2 = 11 - (v2 % 11);
                    }

                    if (k1 != n[9] || k2 != n[10]) {
                        return false;
                    }

                    return true;
                },
            };
            this.fi = {
                valid: function () {
                    if (!/^\d{6}(-|\+|a)\d{3}[a-y0-9]$/i.test(_this.pnr)) {
                        return false;
                    }

                    var c = [
                            0,
                            1,
                            2,
                            3,
                            4,
                            5,
                            6,
                            7,
                            8,
                            9,
                            'A',
                            'B',
                            'C',
                            'D',
                            'E',
                            'F',
                            'H',
                            'J',
                            'K',
                            'L',
                            'M',
                            'N',
                            'P',
                            'R',
                            'S',
                            'T',
                            'U',
                            'V',
                            'W',
                            'X',
                            'y',
                        ],
                        n = parseInt(
                            _this.pnr.substring(0, 6) +
                                _this.pnr.substring(7, 10)
                        );

                    if (
                        c[n % 31] !=
                        _this.pnr.charAt(_this.pnr.length - 1).toUpperCase()
                    ) {
                        return false;
                    }

                    return true;
                },
            };
            this.dk = {
                valid: function () {
                    if (!/^\d{10}$/.test(_this.pnr)) {
                        return false;
                    }

                    var n = _this.pnr.split(''),
                        s =
                            4 * n[0] +
                            3 * n[1] +
                            2 * n[2] +
                            7 * n[3] +
                            6 * n[4] +
                            5 * n[5] +
                            4 * n[6] +
                            3 * n[7] +
                            2 * n[8];

                    if (11 - (s % 11) != n[9]) {
                        return false;
                    }

                    return true;
                },
            };
        }

        init();

        return {
            validate: validate,
            setPage: setPage,
        };
    }

    return Validator;
});
